export const MOMENTS_COACH_FAQS_URL =
  'https://mentoteam.notion.site/Moments-Coach-FAQs-2e61874e1cbf806cb05bf74413caecc2';
